/**
 * Portal screens, the phase that delivers each, and what it will contain.
 * `load` = the screen is built (lazy-loaded); otherwise a placeholder shows the phase.
 */
const accountSettings = () => import('@/features/account/AccountSettingsPage')
export const PORTAL_PAGES = {
  mentee: [
    { path: '', title: 'Dashboard', phase: 2, load: () => import('@/features/mentee/MenteeDashboardPage') },
    { path: 'profile', title: 'Profile', phase: 2, load: () => import('@/features/mentee/profile/MenteeProfilePage') },
    {
      path: 'bookings',
      title: 'Bookings',
      phase: 4,
      load: () => import('@/features/bookings/BookingsPage').then((m) => ({ default: m.MenteeBookingsPage })),
    },
    { path: 'goals', title: 'Goals & progress', phase: 6, load: () => import('@/features/goals/GoalsPage') },
    {
      path: 'messages',
      title: 'Messages',
      phase: 6,
      load: () => import('@/features/messages/MessagesPage').then((m) => ({ default: m.MenteeMessagesPage })),
    },
    { path: 'favourites', title: 'Saved mentors', phase: 3, load: () => import('@/features/mentee/SavedMentorsPage') },
    { path: 'settings', title: 'Settings', phase: 1, load: accountSettings },
  ],
  mentor: [
    { path: '', title: 'Dashboard', phase: 2, load: () => import('@/features/mentor/MentorDashboardPage') },
    { path: 'profile', title: 'Profile', phase: 2, load: () => import('@/features/mentor/profile/MentorProfilePage') },
    { path: 'availability', title: 'Availability', phase: 3, load: () => import('@/features/mentor/AvailabilityPage') },
    {
      path: 'bookings',
      title: 'Bookings',
      phase: 4,
      load: () => import('@/features/bookings/BookingsPage').then((m) => ({ default: m.MentorBookingsPage })),
    },
    { path: 'earnings', title: 'Earnings', phase: 7, load: () => import('@/features/mentor/EarningsPage') },
    {
      path: 'messages',
      title: 'Messages',
      phase: 6,
      load: () => import('@/features/messages/MessagesPage').then((m) => ({ default: m.MentorMessagesPage })),
    },
    { path: 'settings', title: 'Settings', phase: 1, load: accountSettings },
  ],
  admin: [
    { path: '', title: 'Overview', phase: 7, load: () => import('@/features/admin/OverviewPage') },
    {
      path: 'verification',
      title: 'Mentor verification',
      phase: 2,
      load: () => import('@/features/admin/VerificationPage'),
    },
    { path: 'users', title: 'Users', phase: 7, load: () => import('@/features/admin/UsersPage') },
    {
      path: 'bookings',
      title: 'Bookings',
      phase: 7,
      load: () => import('@/features/admin/BookingsAdminPage').then((m) => ({ default: m.AllBookingsPage })),
    },
    {
      path: 'disputes',
      title: 'Disputes',
      phase: 7,
      load: () => import('@/features/admin/BookingsAdminPage').then((m) => ({ default: m.DisputesPage })),
    },
    { path: 'reviews', title: 'Reviews', phase: 7, load: () => import('@/features/admin/ReviewsAdminPage') },
    { path: 'finance', title: 'Finance', phase: 4, load: () => import('@/features/admin/FinancePage') },
    { path: 'skills', title: 'Skill taxonomy', phase: 2, load: () => import('@/features/admin/SkillTaxonomyPage') },
    {
      path: 'settings',
      title: 'Platform settings',
      phase: 1,
      load: () => import('@/features/admin/PlatformSettingsPage'),
    },
    { path: 'account', title: 'My account', phase: 1, load: accountSettings },
    { path: 'audit', title: 'Audit log', phase: 7, load: () => import('@/features/admin/AuditLogPage') },
  ],
}
